export const en = {
    billion: 'billion',
    million: 'million',
    quadrillion: 'quadrillion',
    quintillion: 'quintillion',
    thousand: 'thousand',
    trillion: 'trillion'
};
